import map from './parser-map';
import Team from './Team';
import MatchBet from './MatchBet';
import helpers from '../helpers';

const matchMap = map.match;

class Match {
  constructor(rawObj, noBets = false, outrights = false) {
    this.id = rawObj[matchMap.id];
    this.displayId = rawObj[matchMap.displayId];
    this.name = rawObj[matchMap.name];
    this.shortName = rawObj[matchMap.shortName] || this.name;
    this.idSport = rawObj[matchMap.idSport];
    this.idCategory = rawObj[matchMap.idCategory];
    this.idTournament = rawObj[matchMap.idTournament];
    this.parentTournament = rawObj[matchMap.parentTournament];
    this.position = parseInt(rawObj[matchMap.position], 10) || helpers.maxInt;
    this.totalBets = rawObj[matchMap.totalBets];
    this.timestampUTC = rawObj[matchMap.timestampUTC];
    this.timestamp = rawObj[matchMap.timestamp];
    this.tournamentName = rawObj[matchMap.tournamentName];
    this.tournamentShortName = rawObj[matchMap.tournamentShortName];
    this.isTopOffer = rawObj[matchMap.isTopOffer];
    this.betting = rawObj[matchMap.betting];
    this.active = true;

    if (!noBets) {
      this.bets = _.map(rawObj[matchMap.bets], (value => new MatchBet(value)));
    }

    if (!outrights) {
      this.teams = _.sortBy(_.map(rawObj[matchMap.teams], value => new Team(value)), ['type']);
    }
  }

  mapBets(metaBets) {
    const bets = _.sortBy(_.filter(metaBets, { idSport: this.idSport }), ['position']);
    // Should be configurable
    bets.length = 3;
    const tempMatchBets = [];

    bets.forEach((item) => {
      const index = _.findIndex(this.bets, { id: item.id });

      if (index !== -1) {
        tempMatchBets.push(this.bets[index]);
      } else {
        tempMatchBets.push({
          id: item.id,
          active: true,
          outcomes: item.outcomes,
        });
      }
    });
    this.bets = tempMatchBets;
  }
}

export default Match;
